
/**
 * نقشه‌های بزرگِ جانوران (کاربر، ۸ آبان: «این عکس‌هایی که برات می‌فرستم را به مپِ بازیِ فلش تبدیل کن، در وسعتِ بزرگ»):
 * شیر، اسب و غزال، هر کدام طرحی که از روی عکسِ کاربر کشیده شد — خودِ عکس در بازی نیست، فقط این طرحِ ساده. هر طرح چند
 * چندضلعی (تن)، چند خطِ پهن (شاخِ غزال، از نوک باریک تا پایه پهن)، چند برشِ نازک (دورِ صورتِ شیر، مرزِ یال، چانه) و چند
 * سوراخ (چشم، بینی) است، به درصدِ پهنا و بلندیِ عکس؛ crop قابِ دورِ جانور است.
 *
 * طرح روی هر شبکه‌ای پر می‌شود (animalMask): مرکزِ هر خانه درونِ تن است اگر در یکی از چندضلعی‌ها (زوج‌وفرد) یا نزدیکِ یکی از
 * خط‌های پهن باشد، و بیرون می‌افتد اگر روی برش یا سوراخ باشد. برش و سوراخ دست‌کم یک خانه پهن‌اند و خطِ پهن یک خانه و نیم،
 * تا در شبکه‌ی درشت هم بمانند و پله‌ی خطِ کج به هم برسد (فلش فقط از خانه‌های کنارِ هم می‌گذرد). حساب فقط جمع و ضرب و
 * تقسیم است، پس Go و C# عیناً همین خانه‌ها را می‌گیرند (testdata/arrows_vectors.json).
 *
 * داده از tools/arrow_animals.py ساخته می‌شود؛ animals.go و ArrowsAnimals.cs ِ اپ همان عددها را دارند.
 */
export interface Animal {
  id: string;
  name: string;
  /** پهنا به بلندیِ عکس. */
  aspect: number;
  /** قابِ جانور در عکس: x0، y0، x1، y1 به درصد. */
  crop: [number, number, number, number];
  fill: [number, number][][];
  thick: { pts: [number, number][]; w0: number; w1: number }[];
  cuts: { pts: [number, number][]; w: number }[];
  /** [x، y، شعاعِ افقی، شعاعِ عمودی] — شعاع‌ها به درصدِ پهنا. */
  holes: [number, number, number, number][];
}

export const ANIMALS: readonly Animal[] = [
  {"id":"lion","name":"شیر","aspect":1.2926,"crop":[6,0,95,99],"fill":[[[11,74],[13.09,67.78],[10,62],[13.09,56.22],[11,50],[14.55,45.51],[13,40],[16.55,35.51],[15,30],[19.41,25.97],[19,20],[23.7,17.38],[24,12],[28.5,10.66],[29,6],[32.56,6.58],[33,3],[36.47,4.41],[38,1],[39.84,4.83],[44,4],[44.5,8.66],[49,10],[48.07,14.91],[52,18],[50.45,23.51],[54,28],[51.91,34.22],[55,40],[52.92,44.32],[56,48],[62,51],[70,54],[78,58],[85,63],[90,68],[93,74],[92,80],[48,80],[47,86],[47,92],[46,98],[37,98],[36,92],[37.5,86],[38,80],[21,80],[20.5,86],[20,93],[18,98],[11,98],[10,92],[10,85],[11,78]]],"thick":[],"cuts":[{"pts":[[55.5,47],[53,55],[50.5,63],[48.5,72],[47.5,80]],"w":1.2},{"pts":[[36,17],[32.5,24],[31.5,32],[33.5,40],[38,46],[44.5,47.5],[49.5,43],[51,35],[50,26],[47,19],[42,15.5],[36,17]],"w":1.1}],"holes":[[37,27,1.3,1.0],[44.6,27.6,1.3,1.0],[45.5,37,1.4,1.0]]},
  {"id":"horse","name":"اسب","aspect":1.0,"crop":[21,0,84,100],"fill":[[[62,0],[63.5,0],[64.5,3],[70,3],[71,0],[72.5,0],[73.5,6],[73.5,12],[73,20],[73.5,28],[75.5,34],[77.5,40],[80,48],[81.5,55],[81,62],[78,68],[77,75],[76.5,85],[76,100],[70,100],[69.5,90],[68.5,80],[67.5,73],[65,72.5],[64.5,80],[64,90],[64,100],[58,100],[58,90],[58.5,80],[58,73],[52,71],[48,72],[48,80],[47,90],[46,100],[40,100],[40,92],[38,82],[36.5,76],[35,80],[34.5,90],[34,100],[26,100],[25,90],[25,80],[24.5,70],[24,60],[24.5,50],[26.5,42],[30,38],[35,36],[42,35.5],[49,36],[52,32],[54,28],[56,22],[57,14],[58.5,6],[60,2]]],"thick":[],"cuts":[{"pts":[[50.5,36],[47.5,46],[47.5,56],[50,64]],"w":1.0},{"pts":[[59,34.5],[64,35.5],[69.5,34.5]],"w":0.9},{"pts":[[70.8,6],[71.2,16],[70.8,26],[69.8,33.5]],"w":0.9}],"holes":[[61.2,13.5,1.0,1.2],[72.2,13.5,1.0,1.2]]},
  {"id":"gazelle","name":"غزال","aspect":0.6563,"crop":[12,3,76,98],"fill":[[[44,43],[50,41],[56,41],[60,42],[63,45],[66,52],[68,58],[71,62],[72.5,65],[71,67.8],[67,68.6],[63,67.5],[61,72],[61,80],[62,88],[64,94],[51,96.5],[38,95],[37.5,85],[38,72],[38.5,60],[39.5,52],[41,47]],[[24,37],[30,38.5],[36,41],[40.5,44],[41,47.5],[33,47],[28,44.5],[25,41]],[[61,43],[65,39],[69.5,36],[68.5,40],[65,44]]],"thick":[{"pts":[[14.5,5],[15,12],[16,19],[18.5,23.5],[24,26],[31,28],[37.5,30.5],[43,33.5],[47,37.5],[50,42]],"w0":0.8,"w1":5.0},{"pts":[[54.5,5],[56.5,12],[60,18.5],[65,23.5],[68.5,28],[67,32.5],[63,35.5],[59.5,38.5],[57,42]],"w0":0.8,"w1":5.0}],"cuts":[{"pts":[[61,61],[64.5,64.5],[68,65.5]],"w":0.9}],"holes":[[50,50.8,2.0,1.0],[69,63,0.9,0.7]]}
];

export type AnimalId = "lion" | "horse" | "gazelle";
export const animalOf = (id: string): Animal | undefined => ANIMALS.find((a) => a.id === id);

/** مربعِ فاصله‌ی نقطه تا پاره‌خط — بی sqrt. */
function seg2(px: number, py: number, ax: number, ay: number, bx: number, by: number): number {
  const dx = bx - ax, dy = by - ay;
  const l2 = dx * dx + dy * dy;
  let t = l2 === 0 ? 0 : ((px - ax) * dx + (py - ay) * dy) / l2;
  t = t < 0 ? 0 : t > 1 ? 1 : t;
  const qx = ax + t * dx, qy = ay + t * dy;
  return (px - qx) * (px - qx) + (py - qy) * (py - qy);
}

/** خانه‌های جانور روی شبکه‌ی cols×rows که قابِ crop را می‌پوشاند (سطر به سطر). */
export function animalMask(a: Animal, cols: number, rows: number): boolean[] {
  const asp = a.aspect;
  const [x0, y0, x1, y1] = a.crop;
  // مختصاتِ هم‌سان: x به اندازه‌ی نسبتِ عکس کش می‌آید، y از ۰ تا ۱
  const ix = (x: number) => (x / 100) * asp;
  const iy = (y: number) => y / 100;
  const cell = (y1 - y0) / 100 / rows;
  const out: boolean[] = [];
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const X = ix(x0 + ((c + 0.5) / cols) * (x1 - x0)), Y = iy(y0 + ((r + 0.5) / rows) * (y1 - y0));
      let inside = false;
      for (const poly of a.fill) {
        let odd = false;
        for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
          const xi = ix(poly[i]![0]), yi = iy(poly[i]![1]), xj = ix(poly[j]![0]), yj = iy(poly[j]![1]);
          if ((yi > Y) !== (yj > Y) && X < ((xj - xi) * (Y - yi)) / (yj - yi) + xi) odd = !odd;
        }
        inside = inside || odd;
      }
      for (const th of a.thick) {
        const m = th.pts.length - 1;
        for (let i = 0; i < m; i++) {
          const w = th.w0 + ((th.w1 - th.w0) * i) / (m - 1);
          const rr = Math.max((w / 200) * asp, 0.75 * cell);
          if (seg2(X, Y, ix(th.pts[i]![0]), iy(th.pts[i]![1]), ix(th.pts[i + 1]![0]), iy(th.pts[i + 1]![1])) <= rr * rr) inside = true;
        }
      }
      if (inside) {
        for (const cu of a.cuts) {
          const rr = Math.max((cu.w / 200) * asp, 0.55 * cell);
          for (let i = 0; i + 1 < cu.pts.length; i++) {
            if (seg2(X, Y, ix(cu.pts[i]![0]), iy(cu.pts[i]![1]), ix(cu.pts[i + 1]![0]), iy(cu.pts[i + 1]![1])) <= rr * rr) inside = false;
          }
        }
        for (const [hx, hy, rx, ry] of a.holes) {
          const ex = Math.max((rx / 100) * asp, 0.55 * cell), ey = Math.max((ry / 100) * asp, 0.55 * cell);
          const dx = (X - ix(hx)) / ex, dy = (Y - iy(hy)) / ey;
          if (dx * dx + dy * dy <= 1) inside = false;
        }
      }
      out.push(inside);
    }
  }
  return out;
}

/** پهنا به بلندیِ قابِ جانور. */
export const animalRatio = (a: Animal): number => ((a.crop[2] - a.crop[0]) * a.aspect) / (a.crop[3] - a.crop[1]);

/**
 * نقشه‌ی بزرگِ تک‌نفره (آفلاین): همه‌ی جانور با فلش‌های تک‌رنگ. کاربر نسخه‌ی ۲۶۰ فلشی را «خیلی کوچک» دید و «دست‌کم چهار برابر»
 * خواست؛ سازنده‌اش generateAnimal در coop.ts است (کاشی‌به‌کاشی، بی خطِ میانِ کاشی‌ها).
 */
export const BIG_SPEC = { arrows: 1200, len: 8, turn: 0.5 } as const;
